import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { Col } from 'react-bootstrap';
import AppContext from 'context/Context';
import classNames from 'classnames';

const CustomWidgetSectionTitle = ({
  title,
  subtitle,
  icon,
  transform,
  className
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);
  return (
    <Flex className={className}>
      <span className="fa-stack ms-n1 me-2">
        <img src={icon} alt="" width={50} className="me-2 h-100" />
      </span>
      <Col>
        <h5 className="mb-0 title-text text-primary position-relative">
          <span
            className={classNames('pe-3', {
              'bg-100': isDark,
              'bg-200': !isDark
            })}
          >
            {title}
          </span>
          <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
        </h5>
        <p className="mb-0">{subtitle}</p>
      </Col>
    </Flex>
  );
};

CustomWidgetSectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  transform: PropTypes.string,
  className: PropTypes.string
};

export default CustomWidgetSectionTitle;
